export default __webpack_public_path__ + "static/media/drug.334975e8.jpg";